import * as React from 'react';

import { GetPostListQuery_getPostList, withPostVoteChange } from "@bakbak/controller";

import { PostItemView } from './PostItemView';

interface Props {
  post: GetPostListQuery_getPostList
}

export class PostItemC extends React.PureComponent<Props> {

  render() {
    const { post } = this.props;
    return <PostItemView post={post} />;
  }
}

export const PostItemConnector = withPostVoteChange(PostItemC);



// WEBPACK FOOTER //
// ./src/modules/post/item/PostItemConnector.tsx